import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalAtomComponent } from './modal-atom.component';
import { InputIconModule } from "../../molecules/input-icon/input-icon.component.module";

@NgModule({
  declarations: [ModalAtomComponent],
  imports: [CommonModule, InputIconModule],
  exports: [ModalAtomComponent],
})
export class ModalAtomModule {}
